import { NgModule } from '@angular/core';

import { PaginatorComponent } from './paginator.component';

@NgModule({
  imports: [PaginatorComponent],
  declarations: [],
  exports: [PaginatorComponent]
})
export class TiimePaginatorModule {}
